import { render } from "./ProductDetailsTile.vue?vue&type=template&id=5d39b449&scoped=true"
import script from "./ProductDetailsTile.vue?vue&type=script&lang=ts"
export * from "./ProductDetailsTile.vue?vue&type=script&lang=ts"

import "./ProductDetailsTile.vue?vue&type=style&index=0&id=5d39b449&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d39b449"

export default script